import { roundMoney } from "@react/helpers/helpers"

const round2 = (value) => Math.round((parseFloat(value) || 0) * 100) / 100

export const isCostLine = (line) =>
  line && !line._destroy && line.line_type !== "descriptive" && line.line_type !== "page_break"

export const lineSubtotal = (line) => {
  if (!isCostLine(line)) return 0
  const quantity  = parseFloat(line.quantity) || 0
  const unitPrice = parseFloat(line.unit_price) || 0
  return round2(quantity * unitPrice)
}

// Mirrors the backend recalculate (vat_amount = subtotal * percentage / 100, where
// vat_rate.percentage is stored as e.g. 21.0). Group line subtotals by VAT percentage,
// then roundMoney each group (half-up, like the backend's ROUND_HALF_UP). Purchase
// orders have no order-level discount.
export const computeTotals = (lines, vatRatesById) => {
  const groups = {}
  let subtotal = 0

  lines.forEach((line) => {
    if (!isCostLine(line)) return
    const amount = lineSubtotal(line)
    subtotal += amount
    const vatRate    = vatRatesById[line.vat_rate_id]
    const percentage = vatRate ? parseFloat(vatRate.percentage) || 0 : 0
    groups[percentage] = (groups[percentage] || 0) + amount
  })

  subtotal = round2(subtotal)

  const vatBreakdown = Object.keys(groups)
    .map(parseFloat)
    .filter((percentage) => percentage > 0)
    .sort((first, second) => second - first)
    .map((percentage) => ({ percentage, amount: roundMoney(groups[percentage] * percentage / 100) }))

  const totalVat = round2(vatBreakdown.reduce((accumulator, vat) => accumulator + vat.amount, 0))

  return { subtotal, vatBreakdown, totalVat, total: round2(subtotal + totalVat) }
}

export const formatMoney = (amount, currency = "EUR") =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: currency || "EUR" }).format(amount || 0)
